/* Full Crumb comparison listicle: chart animation, mobile comparison picker, sticky bar. No dependencies. */
(function () {
  document.documentElement.classList.remove('no-js');

  function init() {
    // 1. Animate the comparison chart when it scrolls into view.
    var compares = document.querySelectorAll('[data-fc-compare]');
    if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      compares.forEach(function (el) { io.observe(el); });
    } else {
      compares.forEach(function (el) { el.classList.add('is-in'); });
    }

    compares.forEach(setupCompare);

    // Theme editor: re-run setup when a section is re-rendered while editing.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-fc-compare]').forEach(function (root) { root.classList.add('is-in'); setupCompare(root); });
    });

    setupSticky();
  }

  function setupCompare(root) {
    if (root.dataset.fcReady) return;
    root.dataset.fcReady = '1';
    (function () {
      // 2. Mobile bars: sort "other brands" from highest to lowest active share.
      var others = root.querySelector('[data-fc-others]');
      if (others) {
        var list = others.parentNode;
        var items = Array.prototype.slice.call(list.querySelectorAll('[data-fc-other]'));
        items.sort(function (a, b) { return Number(b.dataset.active) - Number(a.dataset.active); });
        items.forEach(function (li, i) { li.style.setProperty('--i', i + 2); list.appendChild(li); });
      }

      // 3. Mobile systems table: switch which competitor is shown next to Supercrumbs.
      var dataEl = root.querySelector('[data-fc-compare-data]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-fc-chip]'));
      var nameEl = root.querySelector('[data-fc-alt-name]');
      var countEl = root.querySelector('[data-fc-alt-count]');
      var cells = root.querySelectorAll('[data-fc-alt-cell]');

      function show(idx) {
        var c = data[idx];
        if (!c) return;
        chips.forEach(function (chip) {
          var on = Number(chip.dataset.fcChip) === idx;
          chip.setAttribute('aria-checked', on ? 'true' : 'false');
          chip.tabIndex = on ? 0 : -1;
        });
        nameEl.textContent = c.name;
        countEl.textContent = c.partial.filter(Boolean).length + ' of ' + c.partial.length + ' partial';
        cells.forEach(function (cell) {
          var on = c.partial[Number(cell.dataset.fcAltCell)];
          cell.innerHTML = on
            ? '<span class="dot dot-partial" role="img" aria-label="Partial or limited"></span>'
            : '<span class="sr">Not listed</span><span class="dash" aria-hidden="true">\u2013</span>';
        });
      }

      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () { show(Number(chip.dataset.fcChip)); });
        chip.addEventListener('keydown', function (e) {
          var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
          if (!step) return;
          e.preventDefault();
          var next = chips[(i + step + chips.length) % chips.length];
          show(Number(next.dataset.fcChip));
          next.focus();
        });
      });
    })();
  }

  function setupSticky() {
    // 4. Sticky bar: appears once the first button scrolls away, hides when the closing offer is on screen.
    var update = function () {
        var bar = document.querySelector('[data-fc-sticky]');
        if (!bar) return;
        var trigger = document.querySelector('[data-fc-sticky-trigger]');
        var final = document.querySelector('[data-fc-final]');
        var link = bar.querySelector('a');
        var past = trigger ? trigger.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
        var atFinal = final ? final.getBoundingClientRect().top < window.innerHeight : false;
        var on = past && !atFinal;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (link) link.tabIndex = on ? 0 : -1;
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
